import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['input', 'hidden']
  static values  = { source: String }

  #resultados = []

  connect() {
    const input  = this.inputTarget
    const hidden = this.hiddenTarget

    $j(input).autocomplete({
      source: (request, response) => {
        $j.ajax({
          url:      this.sourceValue,
          data:     { term: request.term },
          dataType: 'json',
          success:  (data) => {
            this.#resultados = (data.results || []).slice(0, 10)
            response(this.#resultados.map(r => r[0]))
          },
        })
      },
      minLength: 2,
      select: (event, ui) => {
        const selected = this.#resultados.find(r => r[0] === ui.item.value)
        if (selected) hidden.value = selected[1]
        input.value = ui.item.value
        return false
      },
    })

    $j(input).on('focus.autocomplete', () => {
      if (input.value.length >= 2) $j(input).autocomplete('search', input.value)
    })
  }

  disconnect() {
    const $input = $j(this.inputTarget)
    if ($input.data('ui-autocomplete')) {
      $input.off('focus.autocomplete')
      $input.autocomplete('destroy')
    }
  }
}
